import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-56">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-57">
        <a href="#" className={`text-2xl font-serif font-bold tracking-wide ${isScrolled ? 'text-brand-dark' : 'text-white'}`} data-id="element-58">
          Modern Fix
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-59">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-brand-accent ${isScrolled ? 'text-gray-600' : 'text-gray-200'}`} data-id="element-60">
              {link.name}
            </a>)}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-61">
          {isMobileMenuOpen ? <X className={isScrolled ? 'text-brand-dark' : 'text-white'} size={24} data-id="element-62" /> : <Menu className={isScrolled ? 'text-brand-dark' : 'text-white'} size={24} data-id="element-63" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg py-4 px-6 flex flex-col space-y-4" data-id="element-64">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-dark text-lg font-medium py-2 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)} data-id="element-65">
              {link.name}
            </a>)}
        </div>}
    </nav>;
}